import React from "react";
import "../../stylesheets/screen.css.scss";
import "../../stylesheets/print.css.scss";
import {firstLetterUpperCase} from "../../utils/helpers";
import {Link as ScrollLink} from "react-scroll";
import {Link} from "react-router-dom";
import * as Constants from "../../constants/Constants";
import {MdOutlineKeyboardArrowRight} from "react-icons/md";

const Table = ({data, tableName, tableHeaderKeys}) => {
  const tableHeaders = tableHeaderKeys ? tableHeaderKeys : Object.keys(data?.[0] || {});
  const tableHeaderValues = tableHeaders.map((item) => {
    return firstLetterUpperCase(item);
  });

  // Function to remove "/0" from the "Name" property
  const removeNumber = (name) => {
    if (name) {
      return name.replace(/\/\d+$/, "");
    } else {
      return name;
    }
  };

  const getSchemaId = (name)=>{
    if (name) {
      return Number(name.split("/")[1]);
    } else {
      return name;
    }
  };

  // Function to create arrow based on the number in the "Name" property
  const createArrowHtml = (name) => {
    // Extract the number from the "Name" property by splitting it at '/'
    const arrowCount = Number(name.split("/")[1]);

    // Check if the extracted value is a valid number
    if (!isNaN(arrowCount)) {
    // If it's a valid number, create an array with the arrow components repeated based on the number
      const arrows = [...Array(Number(arrowCount))].map((_, index) => (
        <MdOutlineKeyboardArrowRight key={index} />
      ));
      // Render the array of arrow components within a div
      return <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>{arrows}</div>;
    }
    // If the extracted value is not a valid number, return null (no arrow)
    return null;
  };

  return (
    <table className={tableName===Constants.Values.PROPERTIES?"properties":""}>
      <thead>
        <tr>
          {tableHeaderValues.map((item, index) => {
            return <th key={`data-${index}`}>{item}</th>;
          })}
        </tr>
      </thead>
      {tableName === Constants.Values.TABLE_NAME_RESPONSES && (
        <tbody>
          {data &&
            data.map((items, index) => {
              return (
                <tr key={`row-${index}`}>
                  {tableHeaders.map((each, index) => {
                    return each === Constants.Values.TABLE_HEADER_SCHEMA ? (
                      <td key={`data-${index}`}>
                        <Link>
                          <ScrollLink
                            activeClass="none"
                            to={`${getSchemaId(items[each])}`}
                            spy={true}
                            smooth={true}
                            offset={-150}
                            duration={0}
                          >
                            {removeNumber(items[each])}
                          </ScrollLink>
                        </Link>
                      </td>
                    ) : (
                      <td key={`data-${index}`}>{items[each]}</td>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      )}
      {tableName === Constants.Values.TABLE_NAME_REQUEST_PARAMETERS && (
        <tbody>
          {data &&
            data.map((items, index) => {
              return (
                <tr key={`row-${index}`}>
                  {tableHeaders.map((each, index) => {
                    return each === Constants.Values.TABLE_HEADER_NAME ? (
                      <td key={`data-${index}`}>
                        <Link>
                          <ScrollLink
                            activeClass="none"
                            to={`${getSchemaId(items[each])}`}
                            spy={true}
                            smooth={true}
                            offset={-150}
                            duration={0}
                          >
                            {removeNumber(items[each])}
                          </ScrollLink>
                        </Link>
                      </td>
                    ) : (
                      <td key={`data-${index}`}>{items[each]}</td>
                    );
                  })}
                </tr>
              );
            })}
        </tbody>
      )}
      {tableName === Constants.Values.PROPERTIES && (
        <tbody>
          {data &&
            data.map((items, index) => (
              <tr key={`row-${index}`}>
                {tableHeaders.map((each, columnIndex) => (
                  <td key={`data-${columnIndex}`} style={ each ==="Name" ? {display: "flex", alignItems: "center"}: {}}>
                    {each === "Name" ? (
                      <>
                        {createArrowHtml(items[each])}
                        <span>{removeNumber(items[each])}</span>
                      </>
                    ) : each === "Description" &&
                      items[each]?.includes("refLink/") ? (
                        <Link>
                          <ScrollLink
                            activeClass="none"
                            to={`${getSchemaId(items[each].replace("refLink/", ""))}`}
                            spy={true}
                            smooth={true}
                            offset={-150}
                            duration={0}
                          >
                            {removeNumber(items[each].replace("refLink/", ""))}
                          </ScrollLink>
                        </Link>
                      ) : (
                        items[each]
                      )}
                  </td>
                ))}
              </tr>
            ))}
        </tbody>
      )}
      {tableName !== Constants.Values.TABLE_NAME_REQUEST_PARAMETERS &&
        tableName !== Constants.Values.TABLE_NAME_RESPONSES &&
        tableName !== Constants.Values.TABLE_NAME_PROPERTIES && (
        <tbody>
          {data &&
              data.map((items, index) => {
                return (
                  <tr key={`row-${index}`}>
                    {tableHeaders.map((each, index) => {
                      return <td key={`data-${index}`}>{items[each]}</td>;
                    })}
                  </tr>
                );
              })}
        </tbody>
      )}
    </table>
  );
};

export default Table;
